import { render, staticRenderFns } from "./GamificationHistory.vue?vue&type=template&id=128b7f93&scoped=true"
import script from "./GamificationHistory.vue?vue&type=script&lang=js"
export * from "./GamificationHistory.vue?vue&type=script&lang=js"
import style0 from "./GamificationHistory.vue?vue&type=style&index=0&id=128b7f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b7f93",
  null
  
)

export default component.exports